import { createSelector, createFeatureSelector } from '@ngrx/store';
import { CoreModuleState } from '..';
import * as fromUserProfile from './user-profile.reducer';

export interface UserProfileState {
  userProfile: fromUserProfile.State;
}

const selectCoreModuleState = createFeatureSelector<CoreModuleState>('core');

const selectProfileModuleState = createSelector(selectCoreModuleState, (state: CoreModuleState) => state?.userProfile);

export const selectShowProfileForm = createSelector(selectProfileModuleState, fromUserProfile.getShowProfileForm);

export const selectProfileUser = createSelector(selectProfileModuleState, fromUserProfile.getSelectedUserProfile);

export const selectProfileQueryParams = createSelector(selectProfileModuleState, fromUserProfile.getProfileQueryParams);

export const selectIsProfileSubmitting = createSelector(selectProfileModuleState, fromUserProfile.getIsProfileSubmitting);

export const selectDistanceUnit = createSelector(selectProfileModuleState, fromUserProfile.getDistanceUnit);

export const selectTimezone = createSelector(selectProfileModuleState, fromUserProfile.getTimezone);

export const selectProfileConnection = createSelector(selectProfileModuleState, fromUserProfile.getProfileConnection);

export const selectError = createSelector(selectProfileModuleState, fromUserProfile.getError);

export const selectShowPasswordForm = createSelector(selectProfileModuleState, fromUserProfile.getShowPasswordForm);

export const selectUserOrganizations = createSelector(selectProfileModuleState, fromUserProfile.getUserProfileOrganizations);

export const selectOrganization = createSelector(selectProfileModuleState, fromUserProfile.getOrganization);

export const selectProfileUserUID = createSelector(selectProfileModuleState, fromUserProfile.getSelectedUserProfileUID);

export const selectUserLanguages = createSelector(selectProfileModuleState, fromUserProfile.getUserProfileOrganizationLanguages);

export const selectUserHasLanguages = createSelector(selectProfileModuleState, fromUserProfile.getUserHasLanguages);

export const selectUserHasBusinessUnits = createSelector(selectProfileModuleState, fromUserProfile.getHasBusinessUnits);

export const selectUserBusinessUnits = createSelector(selectProfileModuleState, fromUserProfile.getUserBusinessUnitsList);
